import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../shared/firebase/firebase";
import { toast } from "react-toastify";

function ForgotPassword({ onClose }) {
  const [email, setEmail] = useState("");

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Por favor, introduce tu correo electrónico.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      toast.success("Correo de recuperación enviado. Revisa tu correo.");
      onClose();
    } catch (error) {
      toast.error(
        "No se pudo enviar el correo. Verifica que la dirección sea correcta."
      );
    }
  };

  return (
    <div className="forgotPasswordContainer">
      <h2>Restablecer contraseña</h2>
      <p>
        Introduce tu correo electrónico y recibirás un enlace para restablecer
        tu contraseña.
      </p>
      <form onSubmit={handleResetPassword}>
        <input
          type="email"
          placeholder="Correo electrónico"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button type="submit">Enviar</button>
      </form>
    </div>
  );
}

export default ForgotPassword;
